import React, { useEffect, useState } from 'react';
import { LoadingOutlined, PlusOutlined } from '@ant-design/icons';
import { Flex, message, Upload } from 'antd';
const getBase64 = (img, callback) => {
  const reader = new FileReader();
  reader.addEventListener('load', () => callback(reader.result));
  reader.readAsDataURL(img);
};
const beforeUpload = file => {

  const isLt2M = file.size / 1024 / 1024 / 50 < 2;
  if (!isLt2M) {
    message.error('Image must smaller than 2MB!');
  }
  return isLt2M;
};
const UploadImg = ({ setImgurl, imageUrl, setfileinfo = () => { } }) => {
  const [loading, setLoading] = useState(false);
  const [imageurl, setImageUrl] = useState(imageUrl);
  useEffect(() => {
    setImageUrl(imageUrl);
  }, [imageUrl]);
  const handleChange = info => {
    if (info.file.status === 'uploading') {
      setLoading(true);
      return;
    }
    if (info.file.status === 'done') {

      console.log(info.file);

      // Get this url from response in real world.
      setImgurl(info.file.response.data.file_path);
      setImageUrl(info.file.response.data.file_name);
      setfileinfo(info.file.response.data);
      getBase64(info.file.originFileObj, url => {
        setLoading(false);
        // setImageUrl(url);
      });
    }
  };
  const uploadButton = (
    <button style={{ border: 0, background: 'none' }} type="button">
      {loading ? <LoadingOutlined /> : <PlusOutlined />}
      <div style={{ marginTop: 8 }}>Upload</div>
    </button>
  );
  return (
    <Flex gap="middle" wrap>
      <Upload
        name="file"
        listType="picture-card"
        className="avatar-uploader"
        showUploadList={false}
        action={process.env.REACT_APP_API_URL + "/upload"}
        headers={{
          Authorization: `Bearer ${localStorage.getItem('access_token')}`,
        }}
        capture="environment"
        beforeUpload={beforeUpload}
        onChange={handleChange}
      >
        {imageurl ? (
          <img draggable={false} src={process.env.REACT_APP_URL + imageurl} alt="avatar" style={{ width: '100%' }} />
        ) : (
          uploadButton
        )}
      </Upload>
    </Flex>
  );
};
export default UploadImg;